import { RouterProvider } from 'react-router-dom';
import router from 'routes';
import ScrollTop from 'components/ScrollTop';
import ThemeCustomization from 'themes';
import SnackBarProvider from 'components/third-party/Notistack';
import Snackbar from 'components/@extended/Snackbar';
import { HelmetProvider } from 'react-helmet-async';

function App() {
  return (
    <HelmetProvider>
      <ThemeCustomization>
        <ScrollTop>
          <SnackBarProvider>
            <RouterProvider router={router} />
            <Snackbar />
          </SnackBarProvider>
        </ScrollTop>
      </ThemeCustomization >
    </HelmetProvider>
  );
}

export default App;
